import { Pipe, PipeTransform } from '@angular/core';
/*
 * Usage:
 *   item | searchGame:query
*/
@Pipe({ name: 'searchGame' })
export class SearchGamePipe implements PipeTransform {
    comparer(a, b){
        return parseInt(b.gameId, 10) - parseInt(a.gameId, 10)
    }

    transform(games: any, query: string) {
        let res = []
        if (query === undefined || query.trim() === '') {
            res = games
            res.sort(this.comparer)
            return res
        }
        const splitted = query.split(' ').map(x => x.trim())

        for (const game of games) {
            let addIt = true
            for (const word of splitted) {
                if (game.concatInfo.indexOf(word.toLowerCase()) < 0) {
                    addIt = false
                    break
                }
            }
            if (addIt)
                res.push(game)
        }
        res.sort(this.comparer)
        return res;
    }
}
